import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timespan'
})
export class TimespanPipe implements PipeTransform {

  transform(miliseconds: number | Date, display: 'full' | 'value' | 'type' = 'full', mode: 'absolute' | 'relative' = 'absolute'): number | string {

    if (typeof miliseconds != 'number') miliseconds = (miliseconds as Date).getTime();

    if (mode == 'relative') miliseconds = Date.now() - miliseconds;

    let minutes: number = Math.floor(miliseconds / 60000);

    if (minutes < 1) return display == 'full' ? 'vừa xong' : display == 'value' ? Math.floor(miliseconds / 1000) : 'giây';

    if (minutes < 60) return display == 'full' ? minutes + " phút" : display == 'value' ? minutes : 'phút';

    let hours: number = Math.floor(minutes / 6) / 10;

    if (hours < 24) return display == 'full' ? hours + ' giờ' : display == 'value' ? hours : 'giờ';

    let days: number = Math.floor(hours * 10 / 24) / 10;

    return display == 'full' ? days + ' ngày' : display == 'value' ? days : 'ngày';
  }
}
